/**
 * Created by Andrey Popov on 15.09.2025
 */

const FeedableInfoView = cc.Sprite.extend({
    ctor: function (info, unit) {
        this._super(bundles.merge.frames.feedable_infoview_bg);

        const styles = cleverapps.styles.FeedableInfoView;
        this.unit = unit;
        this.action = () => {
            InfoView.CloseInfo(true);
            const collectible = info.food.findComponent(Collectible);
            collectible.collect(unit);
        };

        const foodIconBg = this.foodIconBg = new cc.Sprite(bundles.merge.frames.feedable_infoview_icon_bg);
        this.addChild(foodIconBg);
        foodIconBg.setAlignment(styles.icon);

        const foodIcon = UnitView.getUnitImage(info.food, {
            alignAnchorX: true,
            preferStatic: true
        });
        foodIconBg.addChild(foodIcon);
        foodIcon.setAlignment(foodIconBg.width / 2, foodIconBg.height / 2);

        const arrow = new cc.Sprite(bundles.merge.frames.feedable_infoview_arrow);
        this.addChild(arrow);
        arrow.setAlignment(styles.arrow);

        cleverapps.UI.onClick(foodIconBg, this.createListener(this.action));

        cleverapps.UI.onDrag(foodIconBg, {
            followPointer: true,
            onDragStart: this.createListener(this.onDragStart.bind(this)),
            onDragMove: this.createListener(this.onDragMove.bind(this)),
            onDragEnd: this.createListener(this.onDragEnd.bind(this))
        });

        cleverapps.UI.applyHover(foodIconBg);

        cleverapps.UI.fitToBox(foodIcon, {
            width: styles.icon.width,
            height: styles.icon.height
        });
        foodIcon.baseScale = foodIcon.scale;
    },

    onDragStart: function () {
        if (this.dragging || Map2d.currentMap.dragging) {
            return false;
        }

        Map2d.currentMap.setDragging(this.action);
        cleverapps.userStatus.reportUserAction();
        this.dragging = true;
        return true;
    },

    onDragMove: function (touch) {
        if (this.dragging) {
            const touchUnit = Map2d.currentMap.getMapView().findTouchUnit(touch);
            if (touchUnit === this.unit) {
                this.unit.highlight();
                this.isCorrectDragPosition = true;
            } else {
                this.unit.unhighlight();
                this.isCorrectDragPosition = false;
            }
        }
    },

    onDragEnd: function () {
        if (this.dragging) {
            this.unit.unhighlight();

            if (this.isCorrectDragPosition) {
                this.foodIconBg.runAction(
                    new cc.Sequence(
                        new cc.ScaleBy(0.2, 0.6).easing(cc.easeBackIn()),
                        new cc.RemoveSelf()
                    )
                ).setFinalize(this.action);
            } else if (this.isRunning()) {
                this.foodIconBg.setAlignment(cleverapps.styles.FeedableInfoView.icon);
            }

            this.isCorrectDragPosition = false;
            this.dragging = false;

            if (Map2d.currentMap.dragging === this.action) {
                Map2d.currentMap.setDragging(undefined);
            }
        }
    }
});

cleverapps.styles.FeedableInfoView = {
    icon: {
        width: 80,
        height: 80,
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    arrow: {
        x: { align: "center", dx: 54 },
        y: { align: "center", dy: -62 }
    }
};
